import React from "react";
import cross_icon from "../../../assets/icons/cross_icon.png";
import { Link } from "react-router-dom";

const PaymentDetailsModal = ({ CloseModal }) => {
  return (
    <>
      <div className={`modal-wrapper overflow-y-auto h-full}`}>
        <div className={`side-modal w-[50%] h-screen}`}>
          <div className="flex mt-10 mb-8 justify-center">
            <div className="flex w-[70%] justify-between">
              <p className="text-[#2F80ED]">Create Subscription Plan </p>
              <div onClick={CloseModal} className="cursor-pointer">
                <img src={cross_icon} alt="cross" />
              </div>
            </div>
          </div>

          <div className="flex justify-center h-[80vh] mb-16">
            <div className="w-[90%] flex flex-col justify-between ">
              <div className="border rounded-lg border-black p-4">
                <p className="text-[14px] text-[#828282] mt-4">
                  Subscription Plan Name
                </p>
                <input
                  type="text"
                  placeholder="Enter the plan name "
                  className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
                />
                <p className="text-[14px] text-[#828282] mt-4">
                  Subscription Plan Pricing
                </p>
                <input
                  type="text"
                  placeholder="Enter the pricing  "
                  className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
                />

                <p className="text-[14px] text-[#828282] mt-4">
                  Subscription Plan Features
                </p>
                <textarea
                  type="text"
                  placeholder="Enter the plan features "
                  className="text-[16px] border w-full h-32 border-[#95C2FF] p-2 rounded-lg"
                />

                <p className="text-[#2F80ED] text-[16px] underline mt-6 cursor-pointer">
                  +Add new plans
                </p>
              </div>

              <div className="flex justify-between text-[14px] mt-4">
                <div className="border border-[#2F80ED] w-[49%] p-2 rounded-lg flex justify-center cursor-pointer">
                  <button>Discord</button>
                </div>
                <Link
                  to="/super-admin/subscription-history"
                  className="bg-[#2F80ED] text-white w-[49%] p-2 rounded-lg flex justify-center cursor-pointer"
                >
                  <button>Save</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentDetailsModal;
